import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IChassisWithCarCodesResponse } from '../search-generic/interfaces/chassis-with-car-codes-response.interface';

@Injectable()
export class AdjuntarDocumentosVehiculoService {

    $mediaFileList = new Subject<any>();

    constructor(private _http: HttpClient) { }

    uploadFile(file: File, vehicle: IChassisWithCarCodesResponse): Observable<any> {
        let formData = new FormData();
        formData.append('Filedata', file, file.name);
        formData.append('storeMode', "database");
        formData.append('clientCode', vehicle.CLIENTCODE);
        formData.append('companyCode', vehicle.COMPANYCODE);
        formData.append('nombreArchivo', file.name);
        formData.append('FileName', file.name);
        formData.append('Upload', "Submit Query");

        let params = new HttpParams();
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.ENDPOINT.FileUpload}`;
        const options = {
            params: params,
            reportProgress: true
        };

        const req = new HttpRequest('POST', _URL_, formData, options);
        return this._http.request(req);
    }

    GetByChassisWithCarCodes(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes`, params)
            .pipe(map((data) => data["Response"]));
    }

    updateVehicle(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/Workshop/VehicleService.svc/AddMediaFile`, params)
            .pipe(map((data) => data["Response"]));
    }

    deleteFile(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/Workshop/VehicleService.svc/DeleteMediaFile`, params)
            .pipe(map((data) => data["Response"]));
    }

    getMediaFileList(): Observable<any> {
        return this.$mediaFileList.asObservable();
    }
    
    setMediaFileList(b: any) {
        this.$mediaFileList.next(b)
    }

}
